import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RightOutlined } from "@ant-design/icons";
import { Layout, Progress, Spin, Tag } from "antd";
import $ from "jquery";
import { isFlowCancellationError } from "mobx";
import { observer } from "mobx-react";
import { Fragment, useCallback, useRef, useState } from "react";
import { RatingPointer } from "@devowl-wp/real-utils";
import { AnalyseFooter } from "./analyseFooter.js";
import { AnalyseItems } from "./analyseItems.js";
import { ProFooter, ProTag } from "./proFooter.js";
import { isDefaultSchema } from "../others/isDefaultSchema.js";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
const { Header, Content } = Layout;
const RegenerateContent = observer(({ onClick })=>{
    const regenerateButtonRef = useRef(null);
    const { optionStore, attachmentsStore, statsStore } = useStores();
    const [regeneratePromise, setGeneratePromise] = useState(null);
    const [forceNewSchema, setForceNewSchema] = useState(false);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [skipExisting, setSkipExisting] = useState(false);
    const { others: { isPro, showProHints, canManageOptions } } = optionStore;
    const { regenerateBusy, regenerated } = attachmentsStore;
    const { busy, imagesCount, schema, sizes } = statsStore;
    const getSelectedSizes = useCallback((pSelectedSizes = selectedSizes, defaultValue = [])=>{
        return pSelectedSizes.length ? pSelectedSizes.slice() : defaultValue;
    }, [
        selectedSizes
    ]);
    const handleStart = useCallback(()=>{
        const start = attachmentsStore.regenerate(getSelectedSizes(undefined, Object.keys(sizes)), forceNewSchema, skipExisting);
        start.catch((e)=>{
            if (isFlowCancellationError(e)) {
            // Silence is golden.
            }
        });
        setGeneratePromise(start);
        optionStore.isRatable && start.then(()=>new RatingPointer(optionStore.slug, $(regenerateButtonRef.current)));
    }, [
        attachmentsStore,
        optionStore,
        getSelectedSizes,
        setGeneratePromise,
        sizes,
        forceNewSchema,
        skipExisting
    ]);
    const handleSizeSelect = useCallback((size)=>{
        const a = getSelectedSizes(selectedSizes);
        const idx = a.indexOf(size);
        if (idx > -1) {
            a.splice(idx, 1);
        } else {
            a.push(size);
        }
        setSelectedSizes(a);
    }, [
        selectedSizes,
        getSelectedSizes,
        setSelectedSizes
    ]);
    return /*#__PURE__*/ _jsxs(Layout, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                style: {
                    background: "#fff"
                },
                children: [
                    __("Thumbnails"),
                    " ",
                    /*#__PURE__*/ _jsx(RightOutlined, {}),
                    " ",
                    __("Bulk regenerate")
                ]
            }),
            /*#__PURE__*/ _jsx(Content, {
                style: {
                    margin: "24px 16px 0"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "rtg-dialog-content",
                    children: [
                        !isPro && showProHints && /*#__PURE__*/ _jsx(ProFooter, {}),
                        /*#__PURE__*/ _jsx(Spin, {
                            spinning: busy,
                            children: /*#__PURE__*/ _jsx("div", {
                                children: regenerateBusy ? /*#__PURE__*/ _jsx("button", {
                                    className: "button",
                                    onClick: regeneratePromise.cancel,
                                    children: __("Cancel (%d of %d regenerated)", regenerated.length, imagesCount)
                                }) : /*#__PURE__*/ _jsx("button", {
                                    className: "button-primary",
                                    onClick: handleStart,
                                    ref: regenerateButtonRef,
                                    children: __("Regenerate all attachments")
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: (showProHints || isPro) && /*#__PURE__*/ _jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsxs("label", {
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "checkbox",
                                                disabled: regenerateBusy || forceNewSchema || !isPro,
                                                checked: skipExisting,
                                                onChange: ()=>setSkipExisting(!skipExisting)
                                            }),
                                            __("Skip files with already existing thumbnails"),
                                            " ",
                                            /*#__PURE__*/ _jsx(ProTag, {
                                                feature: "skip-already-existing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("label", {
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "checkbox",
                                                disabled: regenerateBusy || !isPro,
                                                checked: forceNewSchema,
                                                onChange: ()=>setForceNewSchema(!forceNewSchema)
                                            }),
                                            __("Force regeneration of all thumbnails (and new custom path and filename)"),
                                            " ",
                                            /*#__PURE__*/ _jsx(ProTag, {
                                                feature: "force-schema-mass"
                                            }),
                                            canManageOptions && /*#__PURE__*/ _jsx(Tag, {
                                                onClick: ()=>document.querySelector(`li[data-id="rtg-dialog-menu-item-settings"]`).click(),
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: __("Configure")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !isDefaultSchema(schema) && /*#__PURE__*/ _jsxs("div", {
                            className: "description",
                            children: [
                                __("Thumbnail folder and file name:"),
                                " ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "rtg-highlight-placeholders",
                                    dangerouslySetInnerHTML: {
                                        __html: schema
                                    }
                                })
                            ]
                        }),
                        (showProHints || isPro) && !forceNewSchema && /*#__PURE__*/ _jsxs("p", {
                            children: [
                                __("Regenerates thumbnails in sizes:"),
                                "\xa0",
                                isPro && /*#__PURE__*/ _jsxs(Fragment, {
                                    children: [
                                        "(",
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "#",
                                            onClick: (e)=>{
                                                setSelectedSizes(Object.keys(sizes));
                                                e.preventDefault();
                                                return false;
                                            },
                                            children: __("Select all")
                                        }),
                                        " ",
                                        "|",
                                        " ",
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "#",
                                            onClick: (e)=>{
                                                setSelectedSizes([]);
                                                e.preventDefault();
                                                return false;
                                            },
                                            children: __("Deselect all")
                                        }),
                                        ")"
                                    ]
                                }) || /*#__PURE__*/ _jsx(ProTag, {
                                    feature: "only-checked"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                sizes && Object.keys(sizes).map((size)=>/*#__PURE__*/ _jsxs("label", {
                                        style: {
                                            marginRight: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "checkbox",
                                                disabled: regenerateBusy || !isPro,
                                                checked: selectedSizes.indexOf(size) > -1 || !isPro,
                                                onChange: ()=>handleSizeSelect(size)
                                            }),
                                            " ",
                                            size
                                        ]
                                    }, size))
                            ]
                        }),
                        (regenerateBusy || regenerated.length > 0) && /*#__PURE__*/ _jsx(Progress, {
                            percent: Math.round(regenerated.length / imagesCount * 100),
                            status: regenerateBusy ? "active" : "success"
                        }),
                        /*#__PURE__*/ _jsx(AnalyseItems, {
                            attachments: "regeneratedObjects",
                            onClick: onClick
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(AnalyseFooter, {})
        ]
    });
});
export { RegenerateContent };
